import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import { pinStore } from './pinStore';

const usePinStore = createStore({
  creator: pinStore({
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'pin',
  middlewares: {
    devtools: true,
  },
});

export default usePinStore;
